<template>
  <div class="min-h-screen flex">
    <div @click="showHelp = true">
      <help-button />
    </div>

    <help :show-help="showHelp" @close="showHelp = false" />

    <div class="hidden lg:block w-1/4 bg-white h-screen">
      <router-link
        :to="{ name: 'Login' }"
        class="flex items-center mt-16 ml-16"
      >
        <icon name="logo-neopass" class="text-indigo-600" />
      </router-link>
      <illustration
        class="absolute my-auto inset-0 px-8 py-2 w-1/4"
        name="check_validation"
      />
    </div>
    <div
      class="flex-1 flex flex-col w-3/4 bg-gray-200 rounded-tl-large justify-center py-12 px-4 sm:px-6 lg:flex-none lg:pl-20 xl:pl-24"
    >
      <div class="mx-auto lg:ml-32 w-full max-w-lg">
        <h1 class="text-4xl font-normal leading-none text-gray-900 text-left">
          Creation de votre mot de passe
        </h1>
        <p class="mt-4 text-base font-normal text-gray-600">
          Veuillez saisir un mot de passe qui permettra de vous authentifier.
        </p>

        <div class="mt-8">
          <form action="#" @submit.prevent="createPassword">
            <div class="mt-1 relative rounded-md shadow-sm">
              <input
                id="password"
                :type="passwordFieldType"
                v-model="form.password"
                placeholder="Mot de passe"
                required
                class="appearance-none block w-full text-lg py-5 px-5 border border-indigo-600 rounded-md placeholder-gray-600 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-300 transition duration-150 ease-in-out leading-5 mb-8"
              />
              <div
                class="absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer"
                @click="switchVisibility(1)"
              >
                <icon
                  v-if="passwordFieldType === 'password'"
                  name="eye"
                  class="h-5 w-5 text-pink-600"
                />
                <icon v-else name="eye-off" class="h-5 w-5 text-pink-600" />
              </div>
            </div>

            <div class="mt-1 relative rounded-md shadow-sm">
              <input
                id="password_confirmation"
                :type="passwordFieldType2"
                v-model="form.password_confirmation"
                placeholder="Confirmation du mot de passe"
                required
                class="appearance-none block w-full text-lg py-5 px-5 border border-indigo-600 rounded-md placeholder-gray-600 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-300 transition duration-150 ease-in-out leading-5"
              />
              <div
                class="absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer"
                @click="switchVisibility(2)"
              >
                <icon
                  v-if="passwordFieldType2 === 'password'"
                  name="eye"
                  class="h-5 w-5 text-pink-600"
                />
                <icon v-else name="eye-off" class="h-5 w-5 text-pink-600" />
              </div>
            </div>

            <div
              class="mt-8 space-y-4 flex flex-col items-center sm:space-y-0 sm:flex-row"
            >
              <big-action-button
                border-color="border-transparent"
                text-color="text-white"
                bg-color="bg-pink-600"
                bg-color-square="bg-pink-600"
                icon-color="text-white"
                libelle="CONTINUER"
                :spinner="loading"
                :right="true"
                icon="arrow-right_1"
                type-shadow="shadow-pink"
              />
            </div>

            <v-errors
              :errors="{ ...errors }"
              class="mt-6 text-xs font-medium text-red-500"
            />
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HelpButton from '../../components/HelpButton';
import Help from './popup/Help';
import BigActionButton from './../../components/BigActionButton';
import { mapActions, mapMutations } from 'vuex';
import Icon from '../../components/Icon';
import Illustration from '../../components/Illustration';

export default {
  name: 'CreatePasswordForm',
  components: {
    HelpButton,
    Help,
    BigActionButton,
    Icon,
    Illustration,
  },

  data() {
    return {
      form: {
        token: this.$route.params.token,
        email: this.$route.query.email,
        password: '',
        password_confirmation: '',
      },
      loading: false,
      passwordFieldType: 'password',
      passwordFieldType2: 'password',
      errors: null,
      showHelp: false,
    };
  },

  methods: {
    ...mapMutations({
      SET_ISFIRSTLOGIN: 'auth/SET_ISFIRSTLOGIN',
    }),
    ...mapActions({
      CreateReferentPassword: 'auth/create_referent_password',
    }),

    async createPassword() {
      this.loading = true;
      this.errors = null;

      try {
        await this.CreateReferentPassword(this.form);
        alert(
          "Votre mot de passe a bien été créé. Vous allez être redirigé vers l'application Neopass."
        );

        this.$router.replace({ name: 'Dashboard' });
      } catch (error) {
        console.log('ERROR DETECTED', error);
        this.errors = error.response.data.errors;

        if (error.response.status === 400) {
          alert(error.response.data);
        }
        if (error.response.status === 401) {
          alert(error.response.data);
        }
      }
      this.loading = false;
    },

    switchVisibility(numInput) {
      if (numInput == 1) {
        this.passwordFieldType =
          this.passwordFieldType === 'password' ? 'text' : 'password';
      }
      if (numInput == 2) {
        this.passwordFieldType2 =
          this.passwordFieldType2 === 'password' ? 'text' : 'password';
      }
    },
  },
};
</script>
